<template>
  <div>
    <b-overlay :show="loading" rounded="sm" no-fade>

      <form-wizard color="#7367F0" :title="null" :subtitle="null" layout="vertical" finish-button-text="Salvar"
        back-button-text="Voltar" next-button-text="Próximo" class="wizard-vertical mb-3" @on-complete="formSubmitted">

        <!-- Detalhes -->
        <tab-content title="Detalhes">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Detalhes
              </h5>
              <small class="text-muted">
                Edite as principais informações do grupo.
              </small>
            </b-col>

            <!-- Nome -->
            <b-col cols="12">
              <b-form-group label="Nome" label-for="nome">
                <b-form-input id="nome" v-model="nome" placeholder="Nome" />
              </b-form-group>
            </b-col>

            <!-- alias -->
            <b-col cols="12">
              <b-form-group label="Alias" label-for="alias">
                <b-form-input id="alias" v-model="alias" placeholder="Alias" />
              </b-form-group>
            </b-col>

          </b-row>
        </tab-content>

        <!-- Descrição -->
        <tab-content title="Descrição">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Descrição
              </h5>
              <small class="text-muted">Edite a descrição do grupo</small>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Descrição" label-for="descricao">
                <b-form-textarea id="descricao" v-model="descricao" placeholder="Digite aqui a descrição do grupo"
                  rows="5" :state="descricao.length <= maxChar" class="char-textarea"
                  :class="descricao.length >= maxChar ? 'text-danger' : ''" />
                <small class="textarea-counter-value float-right"
                  :class="descricao.length >= maxChar ? 'bg-danger' : ''">
                  <span class="char-count">{{ descricao.length }}</span> / {{ maxChar }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>
        </tab-content>

        <!-- Imagem -->
        <tab-content title="Imagem">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Imagem
              </h5>
              <small class="text-muted">Edite a imagem do grupo</small>
            </b-col>

            <b-col cols="12" class="mb-1">
              <label for="imagem">Imagens aceitas: .jpg, .png, .gif</label>
              <b-form-file v-model="imageUp" placeholder="Selecione uma imagem" id="imagem" accept=".jpg, .png, .gif" />
            </b-col>

          </b-row>
        </tab-content>
        <tab-content title="Etanol Hidratado">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Etanol Hidratado
              </h5>
              <small class="text-muted">Edite ou adicione os dados de Etanol Hidratado do grupo</small>
            </b-col>
            <!-- f_etanol_hidratado -->
            <b-row>
              <b-col md="12">
                <b-row v-for="(item, index) in f_etanol_hidratado" :id="index" :key="'eta_' + index"
                  ref="rowEtanolHidratado">

                  <!-- f_etanol_hidratado_ano -->
                  <b-col cols="3">
                    <b-form-group label="Ano" label-for="f_etanol_hidratado_ano">
                      <b-form-input id="f_etanol_hidratado_ano" placeholder="Ano" :value="item.ano"
                        v-model="item.ano" />
                    </b-form-group>
                  </b-col>

                  <!-- f_etanol_hidratado_valor -->
                  <b-col cols="7">
                    <b-form-group label="Valor" label-for="f_etanol_hidratado_valor">
                      <b-form-input id="f_etanol_hidratado_valor" placeholder="Valor" :value="item.valor"
                        v-model="item.valor" />
                    </b-form-group>
                  </b-col>

                  <!-- Adicionar Anos -->
                  <b-col cols="2">
                    <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mt-2 mt-md-2"
                      size="sm" @click="removeEtanolHidratado(index)">
                      <feather-icon icon="XIcon" class="mr-25" />
                      <span>Del</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                </b-row>
              </b-col>

              <!-- add Button -->
              <b-col cols="2">
                <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-success" class="mt-0 mt-md-2"
                  size="sm" @click="addEtanolHidratado()">
                  <feather-icon icon="PlusIcon" class="mr-25" />
                  <span>Add</span>
                </b-button>
              </b-col>
            </b-row>
          </b-row>
        </tab-content>
        <tab-content title="Etanol Anidro">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Etanol Anidro
              </h5>
              <small class="text-muted">Edite ou adicione os dados de Etanol Anidro do grupo</small>
            </b-col>
            <!-- f_etanol_anidrro -->
            <b-row>
              <b-col md="12">
                <b-row v-for="(item, index) in f_etanol_anidro" :id="index" :key="'eta_' + index" ref="rowEtanolAnidro">

                  <!-- f_etanol_anidro_ano -->
                  <b-col cols="3">
                    <b-form-group label="Ano" label-for="f_etanol_anidro_ano">
                      <b-form-input id="f_etanol_anidro_ano" placeholder="Ano" :value="item.ano" v-model="item.ano" />
                    </b-form-group>
                  </b-col>

                  <!-- f_etanol_anidro_valor -->
                  <b-col cols="7">
                    <b-form-group label="Valor" label-for="f_etanol_anidro_valor">
                      <b-form-input id="f_etanol_anidro_valor" placeholder="Valor" :value="item.valor"
                        v-model="item.valor" />
                    </b-form-group>
                  </b-col>

                  <!-- Adicionar Anos -->
                  <b-col cols="2">
                    <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mt-2 mt-md-2"
                      size="sm" @click="removeEtanolAnidro(index)">
                      <feather-icon icon="XIcon" class="mr-25" />
                      <span>Del</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                </b-row>
              </b-col>

              <!-- add Button -->
              <b-col cols="2">
                <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-success" class="mt-0 mt-md-2"
                  size="sm" @click="addEtanolAnidro()">
                  <feather-icon icon="PlusIcon" class="mr-25" />
                  <span>Add</span>
                </b-button>
              </b-col>
            </b-row>
          </b-row>
        </tab-content>
        <tab-content title="Custo dos produtos vendidos por safra">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Custo dos produtos vendidos por safra
              </h5>
              <small class="text-muted">Edite o custo dos produtos vendidos por safra do grupo</small>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Custo dos produtos vendidos por safra"
                label-for="custo_dos_produtos_vendidos_por_safra">
                <b-form-textarea id="custo_dos_produtos_vendidos_por_safra"
                  v-model="custo_dos_produtos_vendidos_por_safra"
                  placeholder="Digite aqui o custo dos produtos vendidos por safra do grupo" rows="5"
                  :state="custo_dos_produtos_vendidos_por_safra.length <= maxChar" class="char-textarea"
                  :class="custo_dos_produtos_vendidos_por_safra.length >= maxChar ? 'text-danger' : ''" />
                <small class="textarea-counter-value float-right"
                  :class="custo_dos_produtos_vendidos_por_safra.length >= maxChar ? 'bg-danger' : ''">
                  <span class="char-count">{{ custo_dos_produtos_vendidos_por_safra.length }}</span> / {{ maxChar }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Patrimonio liquido por ano">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Patrimonio liquido por ano
              </h5>
              <small class="text-muted">Edite o patrimonio liquido por ano do grupo</small>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Patrimonio liquido por ano" label-for="patrimonio_liquido_por_ano">
                <b-form-textarea id="patrimonio_liquido_por_ano" v-model="patrimonio_liquido_por_ano"
                  placeholder="Digite aqui o patrimonio liquido por ano do grupo" rows="5"
                  :state="patrimonio_liquido_por_ano.length <= maxChar" class="char-textarea"
                  :class="patrimonio_liquido_por_ano.length >= maxChar ? 'text-danger' : ''" />
                <small class="textarea-counter-value float-right"
                  :class="patrimonio_liquido_por_ano.length >= maxChar ? 'bg-danger' : ''">
                  <span class="char-count">{{ patrimonio_liquido_por_ano.length }}</span> / {{ maxChar }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>
        </tab-content>
      </form-wizard>
    </b-overlay>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BImg,
  BFormFile,
  BOverlay
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt';
import axios from 'axios';

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    ToastificationContent,
    BImg,
    BFormFile,
    BOverlay
  },
  data() {
    return {
      alias: '',
      descricao: '',
      nome: '',
      maxChar: 65535,
      imagem: require('@/assets/images/icons/unknown.png'),
      loading: false,
      imageUp: [],
      f_etanol_hidratado: [],
      f_etanol_anidro: [],
      custo_dos_produtos_vendidos_por_safra: '',
      patrimonio_liquido_por_ano: '',
    }
  },
  methods: {
    addEtanolHidratado() {
      this.f_etanol_hidratado.push({
        id: this.f_etanol_hidratado.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowEtanolHidratado[0].offsetHeight);
      });
    },

    removeEtanolHidratado(index) {
      this.f_etanol_hidratado.splice(index, 1)
      this.trTrimHeight(this.$refs.rowEtanolHidratado[0].offsetHeight)
    },

    addEtanolAnidro() {
      this.f_etanol_anidro.push({
        id: this.f_etanol_anidro.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowEtanolAnidro[0].offsetHeight);
      });
    },

    removeEtanolAnidro(index) {
      this.f_etanol_anidro.splice(index, 1)
      this.trTrimHeight(this.$refs.rowEtanolAnidro[0].offsetHeight)
    },
    redirect() {
      this.$router.replace(`/grupo`);
    },
    async formSubmitted() {
      let params = new FormData();
      params.append('nome', this.nome);
      params.append('alias', this.alias);
      params.append('descricao', this.descricao);
      params.append('imagem', this.imageUp);
      params.append('f_etanol_anidro', this.f_etanol_anidro ? JSON.stringify(this.f_etanol_anidro) : '');
      params.append('f_etanol_hidratado', this.f_etanol_hidratado ? JSON.stringify(this.f_etanol_hidratado) : '');
      params.append('custo_dos_produtos_vendidos_por_safra', this.custo_dos_produtos_vendidos_por_safra);
      params.append('patrimonio_liquido_por_ano', this.patrimonio_liquido_por_ano);

      this.loading = true;
      await useJwt.requestWithFile('/api/grupo/add', params).then(request => {
        this.loading = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: request.data.status,
            text: request.data.msg,
            icon: request.data.status == 'success' ? 'CheckCircleIcon' : 'XCircleIcon',
            variant: request.data.status == 'success' ? 'success' : 'danger',
          },
        });

        if (request.data.status == 'success') {
          setTimeout(this.redirect(), 2000);
        }
      });
    },

  }
}
</script>